export default __webpack_public_path__ + "e81ff22cf0a0899f9710c5b2b9734f2c.png";